<template>
  <el-dialog width="520px" title="批量添加产品"  :before-close="handleClickCancel" :close-on-press-escape="false"
             :close-on-click-modal="false" :visible.sync="productBatchAddVisible">
    <div class="details">

      <el-form  ref="currencyForm "  size="small" v-loading="loading"   label-position="right"   label-width="100px"  :model="currencyForm"  :rules="currencyFormRules">

        <template v-for="(item, index) in currencyData">
          <div class="titleBox">
            <h5>产品{{index+1}}</h5>
            <span class="del_btn" @click="handleClickDel(index)">删除</span>
          </div>
          <el-form :model="item"  :ref="`currencyForm${index}`" label-position="left"   label-width="100px"  :rules="currencyFormRules" size="small">
            <el-form-item prop="product_id" label="产品名">
              <el-select v-model="item.product_id">
                <el-option value="1" label="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="module_require" label="可选模块">
              <el-select v-model="item.module_require">
                <el-option value="1" label="1"></el-option>
              </el-select>
            </el-form-item>

            <el-form-item prop="num" label="数量">
              <el-input-number :controls="false"  v-model="item.num" :min="0" :step="0" placeholder="请输入正整数"></el-input-number>
            </el-form-item>

            <el-form-item prop="order_num" label="订单号">
              <el-input   v-model="item.order_num"  placeholder="请输入订单号"></el-input>
            </el-form-item>

            <el-form-item prop="product_id" label="有效期至">

              <el-date-picker
                v-model="item.date"
                type="datetimerange"
                format="yyyy - MM - dd HH:mm:ss"
                value-format="yyyy-MM-dd HH:mm:ss"
                start-placeholder="开始日期"
                end-placeholder="结束日期">
              </el-date-picker>
            </el-form-item>

            <el-form-item prop="admin_note" label="备注">
              <el-input  type="textarea" v-model="item.admin_note"  placeholder="请输入备注"></el-input>
            </el-form-item>
          </el-form>
        </template>
        <el-button type="text" @click="handleClickAdd">添加</el-button>
      </el-form>

    </div>
    <div slot="footer">
      <el-button  size="small" :disabled="BtnDisabled" @click="handleClickCancel">取消</el-button>
      <el-button  size="small" type="primary" :disabled="BtnDisabled" @click="handleClickConfirm">确认添加</el-button>
    </div>
  </el-dialog>
</template>
<script>

import { } from '@/api/api'
import {mapState} from "vuex";
export default {
  name: 'product_batch_add',
  props: {
    productBatchAddVisible: {
      type: Boolean,
      default: false,
    },
  },
  data() {

    return {
      loading:false,
      BtnDisabled: false,
      currencyData:[
        {
          uid:'',
          company_id: "",
          product_id:'',
          module_require: "ssasa",
          num:undefined,
          order_num: "XS-2024082500001",
          date:'',
          start_date: "",
          end_date: "",
          admin_note: "管理员备注"
        },
      ],
      currencyForm:{
        uid:'',
        company_id: "",
        product_id:'',
        module_require: "ssasa",
        num:undefined,
        order_num: "XS-2024082500001",
        date:'',
        start_date: "",
        end_date: "",
        admin_note: "管理员备注"
      },
      currencyFormRules:{
        product_id:[{ required: true, message: '请选择产品', trigger: 'change'}],
        module_require:[{ required: true, message: '请选择可选模块', trigger: 'change'}],
        num:[{ required: true, message: '请输入数量', trigger: 'blur'}],
        order_num:[{ required: true, message: '请输入订单编号', trigger: 'blur'}],
        date:[{ required: true, message: '请选中有效期至', trigger: 'change'}],
      },
    }
  },

  created() {

  },
  computed: {
    ...mapState(['adminUserInfo']),

  },
  mounted() {

  },
  methods: {
    handleClickAdd(){
      let data =  {
          uid:'',
          company_id: "",
          product_id:'',
          module_require: "ssasa",
          num:undefined,
          order_num: "XS-2024082500001",
          date:'',
          start_date: "",
          end_date: "",
          admin_note: "管理员备注"
        }
      this.currencyData.push(data)
    },
    handleClickDel(index){
      this.currencyData.splice(index,1)
    },
    //根据form表单的ref，动态生成promise，进行表单校验，都通过了再去做处理
    deepFormValidate(name) {
      const that = this
      let res = new Promise(function (resolve, reject) {
        if (Array.isArray(that.$refs[name])) {
          that.$refs[name][0].validate(valid => {
            if (valid) {
              resolve();
            } else {
              reject()
            }
          })
        } else {
          that.$refs[name].validate(valid => {
            if (valid) {
              resolve();
            } else {
              reject()
            }
          })
        }
      })
      return res
    },
    handleClickConfirm(){
      let arrForm = []//哪些表单需要做校验
      let newArr = []
      this.currencyData.map((item, index) => {
        arrForm.push(`currencyForm${index}`)
      })
      arrForm.forEach(item => {
        let res = this.deepFormValidate(item)
        newArr.push(res)
      })
      Promise.all(newArr).then(() => {

        // let postDataInfo = {
        //   file:this.currencyForm.file
        // }
        // this.BtnDisabled = true
        // clipUpload(postDataInfo).then(res => {
        //   if (res.code === 0) {
        //     this.$message({
        //       message: '新增成功',
        //       type: 'success',
        //       duration: 1000,
        //       onClose: () => {
        //         this.BtnDisabled = false
        //         this.$emit('success')
        //         this.$emit('update:productBatchAddVisible', false)
        //       }
        //     })
        //   }else{
        //     this.BtnDisabled = false
        //   }
        // }).catch((e) => {
        //   this.BtnDisabled = false
        // })

      }).catch(() => {
        return false
      })
    },


    //取消事件
    handleClickCancel() {
      //关闭对话框
      this.$emit('update:productBatchAddVisible', false)
    },


  },

}
</script>
<style lang="scss" scoped>
p {
  margin: 0;
  padding: 0;
}
.mt-15{
  margin-top: 15px;
}
.el-select{
  display: block;
}
.tips{
  line-height: 24px;
  margin-bottom: 18px;
  font-size: 14px;
  color: rgba(51, 51, 51, 1);
  text-align: center;
}
::v-deep .el-dialog__body{
  max-height: 60vh;
  overflow-y: auto;
}
::v-deep .el-input-number{
  width: 100%;
  .el-input__inner{
    text-align: left;
  }
}
::v-deep .el-date-editor{
  width: 100%;

}
.titleBox{
  display: flex;
  justify-content: space-between;
  margin-bottom: 16px;
}
.titleBox h5{
  color: rgba(51, 51, 51, 1);
  font-size: 14px;
}
.del_btn{
  cursor: pointer;
  color: rgba(255, 26, 26, 1);
}
</style>
